"use client";

import { motion } from "framer-motion";
import { fadeUp, Section } from "./utils";

const stats = [
  {
    value: "400%",
    label: "More Deals Engaged",
    copy: "When your AI crew acts on a lead in minutes instead of hours, you're in the deal before your competitor even opens the message.",
  },
  {
    value: "24/7",
    label: "Always On",
    copy: "A 10 PM inquiry in Dubai gets worked immediately — qualified, matched, and followed up. Not a \"we'll get back to you\" email the next morning.",
  },
  {
    value: "79%",
    label: "Cost Savings",
    copy: "One Tethra crew replaces 3-4 SaaS tools and the coordination overhead between them.",
  },
];

export function Stats() {
  return (
    <Section className="px-6 py-28 max-w-7xl mx-auto">
      <motion.h2
        variants={fadeUp}
        className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-content text-center mb-4"
      >
        The numbers speak for themselves.
      </motion.h2>
      <motion.p
        variants={fadeUp}
        custom={1}
        className="text-content-muted text-center mb-14 max-w-md mx-auto"
      >
        Manual coordination has a real cost. Here&apos;s what changes when
        agents take over.
      </motion.p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {stats.map((s, i) => (
          <motion.div
            key={i}
            variants={fadeUp}
            custom={i}
            className="text-center md:text-left bg-surface-secondary/50 border border-surface-border rounded-2xl p-8 hover:border-surface-hover transition-all duration-300"
          >
            <p
              className="text-5xl sm:text-6xl font-bold tracking-tight bg-clip-text text-transparent"
              style={{
                backgroundImage:
                  "linear-gradient(to bottom, #DE7356, #b85a3a)",
              }}
            >
              {s.value}
            </p>
            <p className="mt-3 text-sm font-semibold text-content uppercase tracking-wider">
              {s.label}
            </p>
            <p className="mt-3 text-sm text-content-muted leading-relaxed">
              {s.copy}
            </p>
          </motion.div>
        ))}
      </div>
    </Section>
  );
}
